// Français — mirrors en.js key for key. Uses typographic apostrophes (') so
// strings stay single-quote safe. fr distinguishes one/other in CLDR (one
// covers 0 and 1), hence the _one/_other plural pairs.
const fr = {
  // ===== shared =====
  'common.createPlan': 'Créer un plan',
  'common.save': 'Enregistrer',
  'common.cancel': 'Annuler',
  'common.delete': 'Supprimer',
  'common.edit': 'Modifier',
  'common.retry': 'Réessayer',
  'common.activate': 'Activer',
  'common.deactivate': 'Désactiver',
  'common.enabled': 'Activé',
  'common.disabled': 'Désactivé',
  'common.viewTerms': 'Voir les conditions',
  'common.untitledPlan': 'Plan sans titre',
  'common.savedToast': 'Enregistré avec succès',

  // ===== nav / chrome =====
  'nav.home': 'Accueil',
  'nav.plans': 'Plans',
  'nav.settings': 'Paramètres',

  'mismatch.title': 'Incompatibilité d’environnement de déploiement',
  'mismatch.body': 'Cette version du frontend appelle {apiBase}, mais elle est servie depuis {hostname} (attendu : {expected}).',
  'mismatch.contact': 'Veuillez contacter le support technique — il s’agit d’une erreur de configuration de déploiement, pas d’un problème avec votre compte.',

  'install.title': 'Impossible de se connecter à Shopify',
  'install.body': 'Vérifiez que le backend est en cours d’exécution et que sa clé SHOPIFY_API_KEY correspond au client_id de l’application dans shopify.app.toml.',
  'install.retry': 'Réessayer',

  'chrome.loadingBrand': 'FlexCover est en cours de chargement…',
  'error.title': 'Une erreur est survenue',
  'error.reload': 'Recharger',

  'support.badge': 'Vue support',
  'support.shopUnknown': '(boutique inconnue)',
  'support.expired': 'Jeton expiré — régénérez-le dans la console support',
  'support.validUntil': 'Jeton valide jusqu’à {time}',
  'support.exit': 'Quitter',

  // ===== Home =====
  'home.title': 'Bienvenue dans FlexCover : Protection Plans 👋',
  'home.last30days': '30 derniers jours',
  'home.loadingChart': 'Chargement du graphique',
  'home.loadingOverview': 'Chargement de l’aperçu',
  'home.statOrders': 'Commandes avec plans',
  'home.statRevenue': 'Revenu total des plans',
  'home.gettingStarted': 'Premiers pas',
  'home.allSet': 'Tout est prêt 🎉',
  'home.completed': '{done} sur {total} terminés',
  'home.step1.title': 'Créez votre premier plan',
  'home.step1.desc': 'Définissez le prix, la couverture et l’apparence panier de votre offre de protection.',
  'home.step2.title': 'Activez le module d’application',
  'home.step2.desc': 'Activez le bloc FlexCover : Protection Plans pour que le widget apparaisse dans votre panier.',
  'home.step2.enable': 'Activer le module d’application',
  'home.step2.check': 'Vérifier le statut',
  'home.step3.title': 'Obtenez votre première commande protégée',
  'home.step3.desc': 'Une fois le widget en ligne, les clients ajoutent un plan dans le panier — les totaux s’affichent dans les cartes ci-dessus.',
  'home.appEmbed': 'Module d’application',
  'home.checkingEmbed': 'Vérification du statut du module d’application',
  'home.embedEnabledBody': 'Le widget de protection est en ligne sur votre vitrine.',
  'home.embedTheme': '(thème : {theme})',
  'home.embedDisabledBody': 'L’application n’est actuellement pas active sur votre vitrine.',
  'home.embedUnknown': 'Inconnu',
  'home.embedUnknownBody': 'Le statut de la vitrine sera disponible une fois l’application connectée à une boutique.',
  'home.embedUnknownReason': 'Impossible de lire votre thème en ligne pour le moment.',
  'home.enableEmbedHint': 'Dans l’admin Shopify, allez dans Boutique en ligne → Thèmes → Personnaliser → Modules d’application intégrés, puis activez FlexCover : Protection Plans.',
  'home.learnMorePrefix': 'En savoir plus sur ',
  'home.learnMoreLink': 'l’utilisation des plans de protection',

  // ===== Plans list =====
  'plans.title': 'Plans',
  'plans.loading': 'Chargement des plans',
  'plans.errorTitle': 'Impossible de charger les plans',
  'plans.empty.heading': 'Créez votre premier plan de protection',
  'plans.empty.body': 'Proposez protection d’expédition, garanties prolongées, assurance retour et couverture personnalisée — avec la tarification de votre choix.',
  'plans.loadDemo': 'Charger les plans de démo',
  'plans.demoLoaded': 'Plans de démo chargés',
  'plans.demoFailed': 'Échec du chargement des plans de démo : {message}',
  'plans.filterPlaceholder': 'Filtrer les plans',
  'plans.addFilter': 'Ajouter un filtre',
  'plans.statusHeading': 'Statut',
  'plans.typeHeading': 'Type de protection',
  'plans.statusActive': 'Actif',
  'plans.statusInactive': 'Inactif',
  'plans.showing_one': '{count} plan affiché',
  'plans.showing_other': '{count} plans affichés',
  'plans.sortBy': 'Trier par',
  'plans.selectAll': 'Sélectionner tous les plans',
  'plans.selectedCount': '{count} sélectionné(s)',
  'plans.bulkDeleted_one': '{count} plan supprimé',
  'plans.bulkDeleted_other': '{count} plans supprimés',
  'plans.bulkActivated_one': '{count} plan activé',
  'plans.bulkActivated_other': '{count} plans activés',
  'plans.bulkDeactivated_one': '{count} plan désactivé',
  'plans.bulkDeactivated_other': '{count} plans désactivés',
  'plans.deleteBulkFailed': 'Échec de la suppression : {message}',
  'plans.updateBulkFailed': 'Échec de la mise à jour : {message}',
  'plans.activated': 'Plan activé',
  'plans.deactivated': 'Plan désactivé',
  'plans.updateFailed': 'Échec de la mise à jour du plan : {message}',
  'plans.deleted': 'Plan supprimé',
  'plans.deleteFailed': 'Échec de la suppression du plan : {message}',
  'plans.actionsFor': 'Actions pour {name}',
  'plans.activatePlan': 'Activer {name}',
  'plans.deactivatePlan': 'Désactiver {name}',
  'plans.onlineStore': 'Boutique en ligne',
  'plans.optional': 'Optionnel',
  'plans.automatic': 'Automatique',
  'plans.noMatch': 'Aucun plan ne correspond à votre recherche ou à vos filtres.',
  'plans.deleteTitle': 'Supprimer le plan de protection ?',
  'plans.deleteBody': 'sera immédiatement retiré de votre boutique. Les clients ne verront plus cette option de protection.',
  'plans.helpPrefix': 'Besoin d’aide ? ',
  'plans.helpLink': 'Contactez-nous',
  'plans.helpSuffix': ' ou consultez la documentation et les tutoriels de l’application.',

  'sort.date': 'Date (plus récent d’abord)',
  'sort.name': 'Nom (A–Z)',
  'sort.sortOrder': 'Ordre dans le panier',
  'sort.price': 'Prix (croissant)',

  'planType.shipping_protection': 'Protection d’expédition',
  'planType.warranty': 'Garantie',
  'planType.return_insurance': 'Assurance retour',
  'planType.custom': 'Protection personnalisée',
  'planTypeShort.shipping_protection': 'Expédition',
  'planTypeShort.warranty': 'Garantie',
  'planTypeShort.return_insurance': 'Retour',
  'planTypeShort.custom': 'Personnalisée',
  'priceType.fixed': 'Montant fixe',
  'priceType.percentage': 'Pourcentage de la commande',

  // ===== Plan editor page shell =====
  'plan.pageTitle': 'Plan de protection',
  'plan.loading': 'Chargement du plan',
  'plan.notFound.heading': 'Plan introuvable',
  'plan.notFound.body': 'Ce plan de protection a peut-être été supprimé.',
  'plan.backToPlans': 'Retour aux plans',
  'plan.newTitle': 'Nouveau plan de protection',
  'plan.newSubtitle': 'Configurez la tarification et l’apparence panier, puis créez le plan',
  'plan.subtitle': 'Les changements s’appliquent à votre boutique après enregistrement',
  'plan.statusTitle': 'Statut du plan',
  'plan.saveFailed': 'Échec de l’enregistrement du plan : {message}',

  // ===== Plan editor form =====
  'form.section.type': 'Type de protection',
  'form.section.basics': 'Informations de base du plan',
  'form.section.pricing': 'Tarification — {type}',
  'form.pricingFallback': 'Protection',
  'form.section.appearance': 'Apparence',
  'form.section.fulfillment': 'Exécution',

  'form.type.shipping_protection': 'Protection d’expédition',
  'form.type.shipping_protection.help': 'Protège la commande du client contre la perte, les dommages ou le vol pendant l’expédition.',
  'form.type.warranty': 'Garantie',
  'form.type.warranty.help': 'Couvre les défauts de fabrication et l’usure normale pendant une durée déterminée.',
  'form.type.return_insurance': 'Assurance retour',
  'form.type.return_insurance.help': 'Permet aux clients de retourner des articles sous un délai contre un remboursement complet.',
  'form.type.custom': 'Protection personnalisée',
  'form.type.custom.help': 'Votre propre message de couverture personnalisé.',

  'form.defaults.untitledPlan': 'Plan sans titre',
  'form.defaults.viewTerms': 'Voir les conditions',
  'form.defaults.shipping_protection.displayName': 'Protection d’expédition',
  'form.defaults.shipping_protection.description': 'Protégez votre commande contre la perte, les dommages et le vol pendant l’expédition.',
  'form.defaults.warranty.displayName': 'Garantie étendue',
  'form.defaults.warranty.description': 'Couvre les défauts de fabrication et l’usure normale pendant 2 ans.',
  'form.defaults.return_insurance.displayName': 'Assurance retour',
  'form.defaults.return_insurance.description': 'Retournez tout article sous 14 jours et recevez un remboursement complet.',
  'form.defaults.custom.displayName': 'Plan de protection',
  'form.defaults.custom.description': 'Ajoutez une protection à votre commande.',

  'form.lang.select': 'Sélectionner la langue',
  'form.lang.default': '{name} (par défaut)',
  'form.translated': '(traduit)',

  'form.field.planName.label': 'Nom du plan (interne)',
  'form.field.planName.help': 'Pour votre référence uniquement — les clients ne le voient jamais',
  'form.field.nameRequired': 'Le nom interne est requis',
  'form.field.displayName.label': 'Nom d’affichage',
  'form.field.displayNameRequired': 'Le nom d’affichage est requis',
  'form.field.displayName.placeholder': 'Nom d’affichage',
  'form.field.displayName.help': 'Visible par les clients dans le panier et au paiement',
  'form.field.displayName.helpPreset': 'Visible par les clients naviguant en {lang}',
  'form.field.displayName.helpPresetFallback': 'Visible par les clients naviguant en {lang} — les champs vides reviennent au {primary}',
  'form.field.description.label': 'Description',
  'form.field.description.placeholder': 'Description',
  'form.field.description.help': 'Courte description visible par les clients sous le nom du plan',
  'form.field.disabledDescription.label': 'Description si non coché',
  'form.field.disabledDescription.placeholder': 'Facultatif — affiché quand le plan n’est pas sélectionné',
  'form.field.disabledDescription.help': 'Affiché quand la case du plan est décochée (revient à la description ci-dessus si vide)',
  'form.field.footer.label': 'Pied de page',
  'form.field.footerText.label': 'Texte du pied de page',
  'form.field.footerLink.label': 'Lien du pied de page',
  'form.field.footerLink.help': 'Destination du lien du texte du pied de page',

  'form.price.type.label': 'Type de prix',
  'form.price.fixed': 'Montant ($)',
  'form.price.percentage': 'Pourcentage (%)',
  'form.price.advanced': 'Réglage avancé',
  'form.price.pctSummary': '{pct} % du montant de la commande, à partir de ${min} par paliers de ${inc} jusqu’à ${max} — {count} variantes sur le produit du plan',
  'form.price.tiersSummary_one': 'Le produit du plan reçoit 1 variante à {base} plus {count} variante d’intervalle pour les règles de valeur du panier',
  'form.price.tiersSummary_other': 'Le produit du plan reçoit 1 variante à {base} plus {count} variantes d’intervalle pour les règles de valeur du panier',

  'form.validation.priceRequired': 'Saisissez une valeur supérieure à 0',
  'form.validation.priceMax100': 'Le pourcentage ne peut pas dépasser 100',
  'form.validation.warrantyYears': 'Saisissez une durée entre 1 et 5 ans',
  'form.validation.returnDays': 'Saisissez un délai entre 7 et 365 jours',
  'form.validation.maxGreaterThanMin': 'Le maximum doit être supérieur au minimum',
  'form.validation.variantIdNumeric': 'L’identifiant de variante doit être numérique (celui de la variante masquée du plan)',

  'form.icon.label': 'Icône',
  'form.icon.useEmoji': 'Utiliser {emoji} comme icône du plan',
  'form.icon.removeCustom': 'Retirer l’icône personnalisée et utiliser l’icône bouclier',
  'form.icon.upload': 'Téléverser une image d’icône personnalisée',
  'form.icon.uploadButton': 'Téléverser',
  'form.icon.uploading': 'Téléversement de l’icône',
  'form.icon.uploadHelp': 'Téléversez votre propre icône — PNG, JPEG, GIF ou WebP, 5 Mo maximum.',
  'form.icon.error.notImage': 'Veuillez choisir un fichier image (PNG, JPEG, GIF ou WebP).',
  'form.icon.error.tooLarge': 'L’image doit peser 5 Mo ou moins.',

  'form.fulfillment.intro': 'Choisissez quand le produit de protection est marqué comme exécuté.',
  'form.fulfillment.manually': 'Exécution manuelle',
  'form.fulfillment.first_item': 'Marquer comme exécuté lorsque le premier article de la commande est exécuté',
  'form.fulfillment.all_items': 'Marquer comme exécuté lorsque tous les autres articles de la commande sont exécutés',
  'form.fulfillment.immediately': 'Marquer comme exécuté dès la création de la commande',

  'form.adv.title': 'Réglage avancé',
  'form.adv.minPrice': 'Prix minimum',
  'form.adv.minPriceHelp': 'Le prix de la première variante — les frais minimum facturés par le plan',
  'form.adv.increment': 'Montant de l’incrément',
  'form.adv.incrementHelp': 'Pas de prix entre les variantes générées',
  'form.adv.maxPriceLabel': 'Prix maximum : ',
  'form.adv.explanation': 'Le produit du plan est généré avec {buckets} variantes : le prix minimum {min} occupe une variante et les {rest} variantes restantes augmentent par pas de {inc}, jusqu’à un prix maximum de {max}. Au paiement, le client paie la première variante dont le prix est égal ou supérieur à {pct} % du sous-total du panier — un panier de $100 à 2 % cible $2.00, donc la variante à $3.01 s’applique. ',
  'form.learnMore': 'En savoir plus',

  'form.tiers.title': 'Définir le prix par valeur du panier',
  'form.tiers.minCol': 'Valeur minimum du panier',
  'form.tiers.maxCol': 'Valeur maximum du panier',
  'form.tiers.priceCol': 'Prix de la protection',
  'form.tiers.addTier': 'Ajouter un palier',
  'form.tiers.deleteTier': 'Supprimer le palier {index}',
  'form.tiers.explanation': 'Chaque règle nécessite un minimum, un maximum et un prix (les règles peuvent se chevaucher — la première règle correspondante s’applique). Chaque règle devient sa propre variante sur le produit du plan. Si le total du panier ne correspond à aucune règle, le prix fixe du réglage principal s’applique. ',
  'form.tiers.error.minRequired': 'La valeur minimum du panier est requise',
  'form.tiers.error.maxRequired': 'La valeur maximum du panier est requise',
  'form.tiers.error.priceRequired': 'Le prix de la protection est requis',
  'form.tiers.error.pricePositive': 'Le prix doit être supérieur à 0',
  'form.tiers.error.minMax': 'Le minimum doit être inférieur ou égal au maximum',

  // ===== Save bar =====
  'savebar.unsavedChanges': 'Modifications non enregistrées',
  'savebar.discard': 'Abandonner',
  'savebar.saving': 'Enregistrement…',

  // ===== Preview panel =====
  'preview.title': 'Aperçu',
  'preview.simulatedSubtotal': 'Sous-total simulé du panier',
  'preview.cart': 'Panier',
  'preview.product': 'PRODUIT',
  'preview.total': 'TOTAL',
  'preview.subtotal': 'Sous-total',
  'preview.checkout': 'Paiement',
  'preview.noPlans': 'Aucun plan actif pour le moment — les clients ne verront pas ce widget.',
  'preview.autoAdded': 'Ajouté automatiquement',
  'preview.unsaved': 'Non enregistré',

  // ===== Settings page =====
  'settings.title': 'Paramètres',
  'settings.language.title': 'Préférence de langue',
  'settings.language.help': 'Lorsque vous visitez FlexCover, c’est la langue qui vous est affichée. La langue de votre boutique n’est pas affectée.',
  'settings.language.label': 'Langue',
  'settings.language.updated': 'Langue mise à jour',
  'settings.language.saveFailed': 'Échec de l’enregistrement de la préférence de langue : {message}'
};

export default fr;
